import { tv } from "@utils/tw"
import { AnimatePresence, motion } from "motion/react"
import { ReactElement } from "react"

export type BadgeProps = {
  label?: string
  dot?: boolean
  enabled?: boolean
  children: ReactElement
}

export function Badge(props: BadgeProps) {
  const styles = badgeStyles({
    dot: props.dot,
  })
  const label = props.dot ? null : props.label
  return (
    <div className={styles.wrapper()}>
      <AnimatePresence>
        {props.enabled !== false && (
          <motion.span
            key={label}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0 }}
            className={styles.label()}
          >
            {label}
          </motion.span>
        )}
      </AnimatePresence>
      {props.children}
    </div>
  )
}

const badgeStyles = tv({
  slots: {
    wrapper: "relative z-[1]",
    label:
      "absolute -right-3 -top-3 bg-red z-[2] text-white type-caption rounded-sm text-[8px] px-[0.4em] pointer-events-none",
  },
  variants: {
    dot: {
      true: {
        label: "size-[5px] right-[6px] top-[6px] px-0 bg-coral transform translate-x-1/2 -translate-y-1/2 rounded-full",
      },
    },
  },
})
